// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"568":"71c898e4","717":"def608cf","766":"040269c0"}[chunkId] + ".js";
};